import React, {useEffect} from 'react'
import {PricingListTable} from "./PricingListTable";

import Box from "@mui/material/Box";
import {PricingListTableSearchBarHeader} from "./PricingListSearchBarHeader";
import {useUIContext} from "../../contexts/UIContext";
import {PricingListPageMobile} from "./PricingListPageMobile/PricingListPageMobile";
import {useMediaQuery} from "react-responsive";
import {useParams} from "react-router";
import {useShallow} from "zustand/react/shallow";
import {usePricingsStore} from "../../stores/pricingsStore";
import {searchPricings} from "../../utils/utils";
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {useThemeStore} from "../../stores/themeStore";

// 58 (topbar) + 38 (sticky column header row) = 96px reserved for the
// fixed header chrome above the scrollable content.
export const headerHeight = 96

export const PricingListPage = () =>  {
    const params = useParams();
    const { uiState } = useUIContext()
    const {sideNavDrawerWidth} = uiState
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const theme = useThemeStore((state) => state.theme)

    const {
        pricingData,
        setPricingData,
        fetchPricings,
        isLoading,
        search,
    } = usePricingsStore(
        useShallow((state) => ({
            pricingData: state.pricingData,
            setPricingData: state.setPricingData,
            fetchPricings: state.fetchPricings,
            isLoading: state.isLoading,
            search: state.search,
        }))
    )

    const debouncedSearch = useDebounce(search, 500)

    const buildParams = (search) => {
        let queryParams = new URLSearchParams({})

        if (search.length) {
            queryParams.append("s", search)
        }

        return queryParams
    }

    useEffect(() => {
        setPricingData([])
        fetchPricings(params.make)
    }, [params.make])

    useDidMountEffect(function fetchPricingsOnSearch() {
        fetchPricings(params.make, buildParams(debouncedSearch))
    }, [debouncedSearch])

    useEffect(() => {
        return () => {
            setPricingData([])
        }
    }, [])

    const page = () => {
        if (isTabletOrMobile) {
            return <PricingListPageMobile make={params.make}/>
        }

        return (
            <React.Fragment>
                <Box
                    className={'pricing-main'}
                    style={{
                        flexGrow: 1,
                        width: '100%',
                        opacity: isLoading ? .5 : 1
                    }}
                >
                    <Box
                        className={'pricing-topbar-wrap'}
                        style={{
                            width: `calc(100% - ${sideNavDrawerWidth}px)`,
                            zIndex: 11,
                            position: 'fixed',
                        }}
                    >
                        <PricingListTableSearchBarHeader
                            make={params.make}
                            headerHeight={headerHeight - 40}
                        />
                    </Box>
                    <Box style={{ paddingTop: '60px' }}>
                        <PricingListTable
                            pricingData={pricingData}
                            headerHeight={headerHeight}
                        />
                    </Box>
                </Box>
            </React.Fragment>
        )
    }

    return (
        <div id="PricingListPage" data-theme={theme}>
            { page() }
        </div>
    );
}
